module.exports = __webpack_public_path__ + "img/title-bg.26c3aefc.png";